(function(g){
  var LINJEAFSTAND = 1.35;
  var CAP_PR_EM = 0.72;

  var G_CAP = 16.0, G_MARGIN = 3.5, G_SMOOTH = 4.0,
      G_RING_R = 5.0, G_RING_HUL = 2.0, G_OVERLAP = 4.5,
      G_RADIUS = 6.0;

  var _maskeCache = {}, _maskeNoegler = [];
  function cacheHent(n){ return _maskeCache[n]; }
  function cacheLaeg(n, v){
    _maskeCache[n] = v; _maskeNoegler.push(n);
    while(_maskeNoegler.length > 24) delete _maskeCache[_maskeNoegler.shift()];
  }

  function morf(a, W, H, r, udvid){
    var t = new Uint8Array(W*H), u = new Uint8Array(W*H), x, y, k, v, i;
    for(y=0;y<H;y++){
      for(x=0;x<W;x++){
        v = udvid ? 0 : 1;
        for(k=-r;k<=r;k++){
          i = x+k;
          if(i<0||i>=W){ if(!udvid) v = 0; continue; }
          v = udvid ? (v | a[y*W+i]) : (v & a[y*W+i]);
        }
        t[y*W+x] = v;
      }
    }
    for(x=0;x<W;x++){
      for(y=0;y<H;y++){
        v = udvid ? 0 : 1;
        for(k=-r;k<=r;k++){
          i = y+k;
          if(i<0||i>=H){ if(!udvid) v = 0; continue; }
          v = udvid ? (v | t[i*W+x]) : (v & t[i*W+x]);
        }
        u[y*W+x] = v;
      }
    }
    return u;
  }

  var ARBEJDSSKALA = 2.5;

  var MASKE_LOFT_PX = 200000;
  function devicePR(){ return Math.max(1, Math.min(3, window.devicePixelRatio || 1)); }
  function skalaTilMaske(bredde_mm, hoejde_mm, visningsskala){
    var areal = Math.max(1, bredde_mm*hoejde_mm);
    var s = Math.sqrt(MASKE_LOFT_PX/areal);
    return Math.max(ARBEJDSSKALA, Math.min(visningsskala*devicePR(), s));
  }

  function nrPlade(lines, ff, sk, form){
    var noegle = lines.join('')+'|'+ff+'|'+sk.toFixed(3)+'|'+form;
    var haves = cacheHent(noegle);
    if(haves) return haves;

    var fs = G_CAP/CAP_PR_EM * sk;
    var lh = G_CAP*LINJEAFSTAND * sk;
    var m  = G_MARGIN*sk, sm = G_SMOOTH*sk;

    var pad = Math.ceil((m + sm + G_RING_R*sk)*2 + 8);

    var mc = document.createElement('canvas').getContext('2d');
    mc.font = fs+'px '+ff;
    var bred = 0, i;
    for(i=0;i<lines.length;i++) bred = Math.max(bred, mc.measureText(lines[i]).width);
    var W = Math.ceil(bred + pad*2), H = Math.ceil(lines.length*lh + pad*2);

    var c = document.createElement('canvas'); c.width=W; c.height=H;
    var x = c.getContext('2d');
    x.font = fs+'px '+ff; x.textAlign='center'; x.textBaseline='alphabetic';
    var m0 = x.measureText(lines[0]);
    var asc  = m0.fontBoundingBoxAscent  || fs*0.79;
    var desc = m0.fontBoundingBoxDescent || fs*0.21;
    var base0 = pad + asc + (lh - asc - desc)/2;
    var baselines = [];
    for(i=0;i<lines.length;i++) baselines.push(base0 + i*lh);

    var maske;
    if(form === 'fuld'){

      x.fillStyle='#000';
      for(i=0;i<lines.length;i++) x.fillText(lines[i], W/2, baselines[i]);
      var tb = alfaBbox(x.getImageData(0,0,W,H).data, W, H);
      x.clearRect(0,0,W,H);
      var rad = Math.min(G_RADIUS*sk, (tb.maxX-tb.minX)/2, (tb.maxY-tb.minY)/2);
      tegnAfrundet(x, tb.minX-m, tb.minY-m,
                      (tb.maxX-tb.minX)+m*2, (tb.maxY-tb.minY)+m*2, rad);
      x.fillStyle='#000'; x.fill();
      maske = tilMaske(x.getImageData(0,0,W,H).data, W, H);
    } else {

      x.lineWidth = m*2; x.lineJoin='round'; x.lineCap='round';
      x.strokeStyle='#000'; x.fillStyle='#000';
      for(i=0;i<lines.length;i++){
        x.strokeText(lines[i], W/2, baselines[i]);
        x.fillText(lines[i], W/2, baselines[i]);
      }
      maske = tilMaske(x.getImageData(0,0,W,H).data, W, H);

      var r = Math.max(1, Math.round(sm));
      maske = morf(maske, W, H, r, 1);
      maske = morf(maske, W, H, r, 0);
      maske = fyldHuller(maske, W, H);
    }

    var ud = {W:W, H:H, fs:fs, lh:lh, baselines:baselines, sk:sk,
              maske:maske, bbox:alfaBboxMaske(maske, W, H)};
    cacheLaeg(noegle, ud);
    return ud;
  }

  function tilMaske(data, W, H){
    var a = new Uint8Array(W*H);
    for(var i=0;i<W*H;i++) a[i] = data[i*4+3] > 40 ? 1 : 0;
    return a;
  }
  function alfaBbox(data, W, H){
    var minX=W, maxX=-1, minY=H, maxY=-1;
    for(var y=0;y<H;y++) for(var x=0;x<W;x++) if(data[(y*W+x)*4+3]>40){
      if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; }
    return maxX<0 ? {minX:0,maxX:W-1,minY:0,maxY:H-1} : {minX:minX,maxX:maxX,minY:minY,maxY:maxY};
  }
  function alfaBboxMaske(a, W, H){
    var minX=W, maxX=-1, minY=H, maxY=-1;
    for(var y=0;y<H;y++) for(var x=0;x<W;x++) if(a[y*W+x]){
      if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; }
    return maxX<0 ? {minX:0,maxX:W-1,minY:0,maxY:H-1} : {minX:minX,maxX:maxX,minY:minY,maxY:maxY};
  }
  function tegnAfrundet(x, px, py, w, h, r){
    x.beginPath();
    x.moveTo(px+r, py);
    x.lineTo(px+w-r, py); x.quadraticCurveTo(px+w, py, px+w, py+r);
    x.lineTo(px+w, py+h-r); x.quadraticCurveTo(px+w, py+h, px+w-r, py+h);
    x.lineTo(px+r, py+h); x.quadraticCurveTo(px, py+h, px, py+h-r);
    x.lineTo(px, py+r); x.quadraticCurveTo(px, py, px+r, py);
    x.closePath();
  }

  function fyldHuller(a, W, H){
    var ude = new Uint8Array(W*H), stak = [], i, p, px, py;
    for(i=0;i<W;i++){ stak.push(i); stak.push(i+(H-1)*W); }
    for(i=0;i<H;i++){ stak.push(i*W); stak.push(W-1+i*W); }
    while(stak.length){
      p = stak.pop();
      if(ude[p] || a[p]) continue;
      ude[p] = 1;
      px = p % W; py = (p-px)/W;
      if(px>0) stak.push(p-1);
      if(px<W-1) stak.push(p+1);
      if(py>0) stak.push(p-W);
      if(py<H-1) stak.push(p+W);
    }
    for(i=0;i<W*H;i++) if(!a[i] && !ude[i]) a[i] = 1;
    return a;
  }

  function nrRingAnker(P, plac){
    var W=P.W, H=P.H, a=P.maske, bb=P.bbox, sk=P.sk;
    var r = G_RING_R*sk, OL = G_OVERLAP*sk;
    var midY = (bb.minY+bb.maxY)/2, midX = (bb.minX+bb.maxX)/2;

    function kantX(y){
      y = Math.round(y); if(y<0||y>=H) return null;
      var L=null, R=null, i;
      for(i=0;i<W;i++) if(a[y*W+i]){ L=i; break; }
      if(L===null) return null;
      for(i=W-1;i>=0;i--) if(a[y*W+i]){ R=i; break; }
      return {L:L, R:R};
    }
    function kantY(x){
      x = Math.round(x); if(x<0||x>=W) return null;
      var T=null, B=null, i;
      for(i=0;i<H;i++) if(a[i*W+x]){ T=i; break; }
      if(T===null) return null;
      for(i=H-1;i>=0;i--) if(a[i*W+x]){ B=i; break; }
      return {T:T, B:B};
    }

    if(plac==='venstre' || plac==='hoejre'){
      var e = kantX(midY) || {L:bb.minX, R:bb.maxX};
      return {cx:(plac==='venstre') ? e.L - r + OL : e.R + r - OL, cy:midY, r:r};
    }
    if(plac==='top' || plac==='bund'){
      var f = kantY(midX) || {T:bb.minY, B:bb.maxY};
      return {cx:midX, cy:(plac==='top') ? f.T - r + OL : f.B + r - OL, r:r};
    }

    var hx = (plac.indexOf('venstre')===0) ? bb.minX : bb.maxX;
    var hy = (plac.indexOf('-top')>-1)     ? bb.minY : bb.maxY;
    var bedst=null, bedstD=Infinity, y2, e2, s, dx, dy, d;
    for(y2=bb.minY; y2<=bb.maxY; y2++){
      e2 = kantX(y2); if(!e2) continue;
      for(s=0;s<2;s++){
        var xx = s ? e2.R : e2.L;
        dx = xx-hx; dy = y2-hy; d = dx*dx + dy*dy;
        if(d < bedstD){ bedstD = d; bedst = {cx:xx, cy:y2}; }
      }
    }
    if(!bedst) bedst = {cx:hx, cy:hy};
    return {cx:bedst.cx, cy:bedst.cy, r:r};
  }

  function nrTegnEmne(cv, lines, ff, sk, plac, form, baseFarve, tekstFarve){

    var P = nrPlade(lines, ff, ARBEJDSSKALA, form);
    var bm = (P.bbox.maxX-P.bbox.minX)/ARBEJDSSKALA + G_RING_R*2;
    var hm = (P.bbox.maxY-P.bbox.minY)/ARBEJDSSKALA + G_RING_R*2;
    var mSk = skalaTilMaske(bm, hm, sk);
    if(mSk > ARBEJDSSKALA + 0.01) P = nrPlade(lines, ff, mSk, form);
    else mSk = ARBEJDSSKALA;

    var A = nrRingAnker(P, plac);
    var aW = P.W, aH = P.H, hulR = G_RING_HUL*mSk;
    var op = sk / mSk;

    var off = document.createElement('canvas');
    off.width = aW; off.height = aH;
    var oc = off.getContext('2d');
    var img = oc.createImageData(aW,aH);
    var rgb = hexRgb(baseFarve);
    var minX=aW, maxX=-1, minY=aH, maxY=-1;
    var px, py, i, dx, dy, d2, inde;
    for(py=0;py<aH;py++){
      for(px=0;px<aW;px++){
        i = py*aW+px;
        dx = px-A.cx; dy = py-A.cy; d2 = dx*dx + dy*dy;
        inde = (P.maske[i]===1) || (d2 <= A.r*A.r);
        if(inde && d2 > hulR*hulR){
          img.data[i*4]=rgb[0]; img.data[i*4+1]=rgb[1];
          img.data[i*4+2]=rgb[2]; img.data[i*4+3]=255;
          if(px<minX)minX=px; if(px>maxX)maxX=px;
          if(py<minY)minY=py; if(py>maxY)maxY=py;
        }
      }
    }
    oc.putImageData(img,0,0);
    if(maxX<0){ minX=0; maxX=aW-1; minY=0; maxY=aH-1; }

    var W = Math.max(1, Math.round(aW*op)), H = Math.max(1, Math.round(aH*op));

    var DPR = devicePR();
    cv.width = Math.round(W*DPR); cv.height = Math.round(H*DPR);
    cv.style.width = W+'px'; cv.style.height = H+'px';
    var x = cv.getContext('2d');
    x.setTransform(DPR,0,0,DPR,0,0);
    x.clearRect(0,0,W,H);
    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    x.drawImage(off, 0, 0, W, H);

    var fsVis = G_CAP/CAP_PR_EM * sk;
    var lhVis = G_CAP*LINJEAFSTAND * sk;
    x.font = fsVis+'px '+ff; x.textAlign='center'; x.textBaseline='alphabetic';
    x.fillStyle = tekstFarve;
    for(i=0;i<lines.length;i++) x.fillText(lines[i], W/2, P.baselines[i]*op);

    return {W:W, H:H, P:P, A:A, op:op, maskeskala:mSk,
            ring:{cx:A.cx*op, cy:A.cy*op, r:A.r*op},
            emne:{minX:minX*op, maxX:maxX*op, minY:minY*op, maxY:maxY*op},
            bredde_mm:(maxX-minX)/mSk, hoejde_mm:(maxY-minY)/mSk};
  }

  function hexRgb(h){
    h = String(h).replace('#','');
    return [parseInt(h.substr(0,2),16), parseInt(h.substr(2,2),16), parseInt(h.substr(4,2),16)];
  }

  g.K3Noeglering = { nrPlade:nrPlade, nrTegnEmne:nrTegnEmne, ARBEJDSSKALA:ARBEJDSSKALA, G_RING_R:G_RING_R, CAP_PR_EM:CAP_PR_EM, LINJEAFSTAND:LINJEAFSTAND };
})(window);
